import type { FormEvent } from 'react';
import { sanitize } from '../lib/format';

interface Props {
  phase:           string;
  voucher:         string;
  codeFromQR:      boolean;
  onVoucherChange: (v: string) => void;
  errMsg:          string;
  onSubmit:        (e: FormEvent) => void;
}

const VoucherSection = ({ phase, voucher, codeFromQR, onVoucherChange, errMsg, onSubmit }: Props) => {
  const busy = phase === 'busy-free' || phase === 'busy-voucher';

  return (
    <form onSubmit={onSubmit}>
      <input
        className={`code-input${phase === 'err-voucher' ? ' code-input-err' : ''}`}
        type="text"
        inputMode="text"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="characters"
        spellCheck={false}
        placeholder="ZUGANGSCODE"
        value={voucher}
        disabled={busy}
        readOnly={codeFromQR}
        maxLength={16}
        onChange={e => onVoucherChange(sanitize(e.target.value))}
      />
      {phase === 'err-voucher' && <p className="err-msg">{errMsg}</p>}
      <button className="btn btn-secondary" type="submit" disabled={!voucher || busy}>
        {phase === 'busy-voucher'
          ? <span className="spinner spinner-light" />
          : codeFromQR ? 'Akzeptieren & Verbinden' : 'Einloggen mit Code'}
      </button>
      <p className="tier-hint">Surfdauer: 4 Stunden</p>
    </form>
  );
};

export default VoucherSection;
